import { useMutation, useQueryClient } from "@tanstack/react-query";

import { resendInvite } from "@/adapters/api";

export function useResendInvite() {
	const queryClient = useQueryClient();

	return useMutation({
		mutationFn: (id: string) => resendInvite(id),
		onSuccess: () => {
			queryClient.invalidateQueries({ queryKey: ["invites"] });
		},
	});
}
